import { Skin } from "@Enums/skin"

export class SkinHelper {
    public static updateSkin(newSkin: Skin, oldSkin: Skin = Skin.Default) {
		if (newSkin === oldSkin) return
		
		document.documentElement.classList.remove(oldSkin)
		document.documentElement.classList.add(newSkin)
	}
}